module.exports = __webpack_public_path__ + "img/point_ending_w.9c7617b6.svg";